import React, { useEffect, useState, useContext, useRef } from "react";
// import { SliderPicker } from "react-color";
import OptionPopUp from "./optionPopUp";
import { editLayerMotion } from "./MotionOverlay";
import { hasMotion } from "../../Utils/layerMotion";
import MyContext from "../../context/MyContext";
import arrayMove from "array-move";

export const FurtherSetting = (props) => {
  const {
    setLayersData,
    LayersData,
    clone,
    setRedoLayer,
    UndoLayer,
    setUndoLayer,
    ChangeCount,
    setChangeCount,
    setChrPopData,
    setCharacterData,
    setchrPop,
    EditorZoom,
    setBackgrounds,
  } = useContext(MyContext);

  var [AnimatedTextData, setAnimatedTextData] = useState([]);

  var GoogleFonts = require("../../assets/GoogleFonts.json");

  const StackStore = () => {
    return new Promise((resolve) => {
      let stack = [...UndoLayer];
      let PrevArray = clone(LayersData);
      if (stack.length < 10) {
        stack.push(PrevArray);
        setUndoLayer(stack);
        setRedoLayer([]);
      } else {
        stack.shift();
        stack.push(PrevArray);
        setUndoLayer(stack);
        setRedoLayer([]);
      }
      resolve();
    });
  };

  var Fsize, currsize;

  const [DecrMouseDownInterval, setDecrMouseDownInterval] = useState(null);

  const [IncrMouseDownInterval, setIncrMouseDownInterval] = useState(null);

  const [State, setState] = useState(false);

  const decrSizeMouseDown = () => {
    setDecrMouseDownInterval(setInterval(decrSize, 33));
  };

  const decrSizeMouseUp = () => {
    if (DecrMouseDownInterval) {
      clearInterval(DecrMouseDownInterval);
      setChangeCount(ChangeCount + 1);
    }
  };

  const incrSizeMouseDown = () => {
    setIncrMouseDownInterval(setInterval(incrSize, 33));
  };

  const incrSizeMouseUp = () => {
    if (IncrMouseDownInterval) {
      clearInterval(IncrMouseDownInterval);
      setChangeCount(ChangeCount + 1);
    }
  };

  const decrSize = async () => {
    await StackStore();
    currsize = props.values.fontSize - 1;
    const array = Array.from(LayersData);

    for (let i = 0; i < array.length; i++) {
      if (array[i].key === props.values.key) {
        array[i].fontSize = currsize;
        array[i].originalFontSize = currsize;
        let elm = document.getElementById("Text-" + props.values.AnimationId);

        let text = document.getElementById(
          "Text-" + props.values.AnimationId
        ).offsetParent;

        if (text.offsetWidth < elm.offsetWidth) {
          array[i].width = elm.offsetWidth;
        } else {
          array[i].width = text.offsetWidth;
        }
        if (text.offsetHeight < elm.offsetHeight) {
          array[i].height = elm.offsetHeight;
        } else {
          array[i].height = text.offsetHeight;
        }
        array[i].isFontButtonClick = true;
        break;
      }
    }
    setLayersData(array);
  };

  const incrSize = async () => {
    await StackStore();
    currsize = props.values.fontSize + 1;

    const array = Array.from(LayersData);

    for (let i = 0; i < array.length; i++) {
      if (array[i].key === props.values.key) {
        array[i].fontSize = currsize;
        array[i].originalFontSize = currsize;
        let elm = document.getElementById("Text-" + props.values.AnimationId);

        let text = document.getElementById(
          "Text-" + props.values.AnimationId
        ).offsetParent;

        if (text.offsetWidth < elm.offsetWidth) {
          array[i].width = elm.offsetWidth;
        } else {
          array[i].width = text.offsetWidth;
        }
        if (text.offsetHeight < elm.offsetHeight) {
          array[i].height = elm.offsetHeight;
        } else {
          array[i].height = text.offsetHeight;
        }
        array[i].isFontButtonClick = true;
        break;
      }
    }
    setLayersData(array);
  };

  const [fontsize, setfontsize] = useState();

  useEffect(() => {
    if (props.values.fontSize) {
      Fsize = props.values.fontSize;
      setfontsize(Fsize);
    }
  }, [props]);

  const fontBold = async () => {
    await StackStore();

    const array = Array.from(LayersData);

    for (let i = 0; i < array.length; i++) {
      if (array[i].key === props.values.key) {
        if (props.values.fontWeight === "normal") {
          array[i].fontWeight = "bold";
        } else {
          array[i].fontWeight = "normal";
        }
        break;
      }
    }
    setLayersData(array);
    setChangeCount(ChangeCount + 1);
  };

  const FontItalic = async () => {
    await StackStore();
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === props.values.key) {
        if (props.values.Fontstyle === "normal") {
          array[i].Fontstyle = "italic";
        } else {
          array[i].Fontstyle = "normal";
        }
        break;
      }
    }
    setLayersData(array);
    setChangeCount(ChangeCount + 1);
  };

  const openCropper = () => {
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === props.values.key) {
        if (props.values.crop === "false") {
          array[i].crop = "true";
          array[i].FurtherSetting = false;
          array[i].DrapEndAnimatedText = true;
        }
        break;
      }
    }
    setLayersData(array);
    setChangeCount(ChangeCount + 1);
  };

  const TextUnderline = async () => {
    await StackStore();
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === props.values.key) {
        if (props.values.textDec === "none") {
          array[i].textDec = "underline";
        } else {
          array[i].textDec = "none";
        }
        break;
      }
    }

    setLayersData(array);
    setChangeCount(ChangeCount + 1);
  };

  const Aligned = async (obj) => {
    await StackStore();
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === props.values.key) {
        array[i].Align = obj;
        break;
      }
    }

    setLayersData(array);
    setChangeCount(ChangeCount + 1);
  };

  const OpacityChanger = (e) => {
    props.setoverlaydiv(true);
    props.setSliderShow(true);
  };

  const TransparencyChanger = (e) => {
    props.setoverlaydiv(true);
    props.setStrokeShow(true);
  };

  const ColorSetter = (e) => {
    // debugger
    props.setoverlaydiv(true);
    props.setcolorShow(true);
  };

  const FontsSetter = (e) => {
    props.setoverlaydiv(true);
    props.setFontShow(true);
  };

  const OverlayTouch = () => {
    props.setoverlayHide(false);
    props.setoverlaydiv(false);
    props.setcolorShow(false);
    props.setSliderShow(false);
    props.setStrokeShow(false);
  };

  const FlipFun = async (e) => {
    await StackStore();

    const array = Array.from(LayersData);

    for (let i = 0; i < array.length; i++) {
      if (array[i].key === props.values.key) {
        if (array[i].flip === "scaleX(1)") {
          array[i].flip = "scaleX(-1)";
        } else {
          array[i].flip = "scaleX(1)";
        }
        break;
      }
    }

    setLayersData(array);
    setChangeCount(ChangeCount + 1);
  };

  const lockFun = async () => {
    const array = Array.from(LayersData);

    for (let i = 0; i < array.length; i++) {
      if (array[i].key === props.values.key) {
        array[i].lock = !array[i].lock;
        array[i].Editable = false;
        break;
      }
    }
    setLayersData(array);
  };

  const setImgAsBG = async () => {
    setBackgrounds({
      type: "image",
      color: null,
      Path: props.values.ImageSrc,
      gradient: { Gcolor: null, FirstColor: null, SecondColor: null },
    });
    const array = Array.from(LayersData);
    var changeArray = array.filter((item) => item.key !== props.values.key);
    setLayersData(changeArray);
    setChangeCount(ChangeCount + 1);
  };

  const setTransparancy = async () => {
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === props.values.key) {
        array[i].transparency = !array[i].transparency;
        array[i].Editable = false;
        break;
      }
    }
    setLayersData(array);
  };

  const openPoses = (event) => {
    const Data = props.values;
    var poseList = Data.character_poses,
      //gender = Data.character_Gender,
      name = Data.character_Name,
      FileName = Data.character_FilePath,
      miniImg = Data.ImageSrc;
    var offsets = event.target.getBoundingClientRect();
    var leftside = Math.round(offsets.x + offsets.width + 15);
    var topside = Math.round(offsets.y);
    if (topside <= 185) {
      topside = 186;
    }
    let ChangePose = true;
    let prvKey = Data.key;
    setChrPopData({ left: leftside, top: topside });

    if (props.values.character_FilePath.includes("Male")) {
      let gender = "Male";
      setCharacterData({
        poseList,
        gender,
        name,
        FileName,
        miniImg,
        ChangePose,
        prvKey,
      });
    } else {
      setCharacterData({
        poseList,
        name,
        FileName,
        miniImg,
        ChangePose,
        prvKey,
      });
    }

    setchrPop(true);
  };

  const LayerArrange = () => {
    let index = null;
    for (let i = 0; i < LayersData.length; i++) {
      if (LayersData[i].key == props.values.key) {
        index = i;
      }
    }
    if (index != null) {
      if (LayersData.length >= index + 1) {
        let data = arrayMove(LayersData, index, index + 1);
        setLayersData(data);
      }
    }
  };

  const [position, setposition] = useState({
    y: 0,
    x: 0,
  });

  const containerRef = useRef();

  useEffect(() => {
    AnimatedTextData = [];

    if (props.values.type === "AnimatedText") {
      let _value = props.values;

      setAnimatedTextData(_value);
      _value = [];
    }
  }, [props.values.FurtherSetting]);

  useEffect(() => {
    //debugger;
    containerRef.current.focus();
    if (parseInt(props.values.y) < 0 && parseInt(props.values.x) > 0) {
      setposition({ x: (props.values.x * EditorZoom) / 100, y: 0 });
    } else if (
      parseInt(props.values.x) - 155 < 0 &&
      parseInt(props.values.y) > 0
    ) {
      if (
        parseInt(props.values.y) + containerRef.current.offsetHeight >=
        parseInt(props.parentHeight)
      ) {
        setposition({
          x: props.values.x + props.values.width + 155,
          y: parseInt(props.parentHeight) - containerRef.current.offsetHeight,
        });
      } else {
        setposition({
          x: props.values.x + props.values.width + 155,
          y: (props.values.y * EditorZoom) / 100,
        });
      }
    } else if (parseInt(props.values.x) < 0 && parseInt(props.values.y) > 0) {
      if (
        parseInt(props.values.y) + containerRef.current.offsetHeight >=
        parseInt(props.parentHeight)
      ) {
        setposition({
          x: props.values.x + props.values.width + 155,
          y: parseInt(props.parentHeight) - containerRef.current.offsetHeight,
        });
      } else {
        setposition({
          x: props.values.x + props.values.width + 155,
          y: (props.values.y * EditorZoom) / 100,
        });
      }
    } else if (parseInt(props.values.x) < 0 && parseInt(props.values.y) < 0) {
      setposition({ x: props.values.x + props.values.width + 155, y: 0 });
    } else if (parseInt(props.values.x) > 0 && parseInt(props.values.y) > 0) {
      let subtractedHeight =
        parseInt(props.parentHeight) -
        parseInt((props.values.y * EditorZoom) / 100);
      if (
        parseInt(props.parentHeight) -
          subtractedHeight +
          containerRef.current.offsetHeight >=
        parseInt(props.parentHeight)
      ) {
        setposition({
          x: (props.values.x * EditorZoom) / 100,
          y: parseInt(props.parentHeight) - containerRef.current.offsetHeight,
        });
      } else {
        setposition({
          x: (props.values.x * EditorZoom) / 100,
          y: (props.values.y * EditorZoom) / 100,
        });
      }
    }
  }, [containerRef]);

  const out = (e) => {
    if (
      props.SliderShow !== true &&
      props.colorShow !== true &&
      props.StrokeShow !== true &&
      (!e.relatedTarget ||
        e.relatedTarget.hasAttribute("contenteditable") != true) &&
      e.relatedTarget &&
      e.relatedTarget.className &&
      e.relatedTarget.className != "boxBottom font-setter"
    ) {
      var index = LayersData.findIndex((x) => x.key === props.values.key);
      LayersData[index].FurtherSetting = false;
      setLayersData(LayersData);
      props.setcolorShow(false);
      props.setSliderShow(false);
      props.setStrokeShow(false);
    }
  };

  // Move A → Z: closes these settings and opens the path editor on the canvas (MotionOverlay).
  const MoveAtoZ = () => {
    const index = LayersData.findIndex((x) => x.key === props.values.key);
    if (index >= 0) {
      const array = Array.from(LayersData);
      array[index].FurtherSetting = false;
      setLayersData(array);
    }
    editLayerMotion(props.values.key);
  };

  const AtoZ = () => {
    let Array = [];
    var index = LayersData.findIndex((x) => x.key === props.values.key);
    LayersData[index].FurtherSetting = false;
    LayersData[index].Editable = false;
    LayersData[index].BoxId = "box1";
    Array.push(clone(LayersData[index]));

    if (LayersData[index].AzData == null) {
      const array2 = clone(props.values);
      let obj = {
        x: array2.x + 20,
        y: array2.y + 20,
        width: array2.width + 20,
        height: array2.height + 20,
        rotateAngle: array2.rotateAngle,
        key: array2.key + 1,
        BoxId: "box2",
        widthOnTimeline: LayersData[index].widthOnTimeline / 2,
      };
      Array.push(clone(obj));
    } else {
      Array.push(clone(LayersData[index].AzData));
    }
    props.setAtoZ(Array);
    setLayersData(LayersData);
  };

  const Duplicate = (params) => {
    var typelength = 1;
    var checkKey = 0;
    var topIndex = 0;

    if (LayersData.length > 0) {
      topIndex = LayersData[LayersData.length - 1].layerIndex;
      topIndex = topIndex + 1;
    }

    for (var i = 0; i < LayersData.length; i++) {
      if (LayersData[i].type === props.type) {
        typelength = typelength + 1;
      }
      if (LayersData[i].key >= checkKey) {
        checkKey = LayersData[i].key;
      }
      if (LayersData[i].Editable === true) {
        LayersData[i].Editable = false;
      }
      if (LayersData[i].FurtherSetting === true) {
        LayersData[i].FurtherSetting = false;
      }
    }

    const array2 = clone(props.values);
    array2.key = checkKey + 1;
    array2.x = array2.x + 10;
    array2.y = array2.y + 10;
    array2.Name = `${props.type}-${typelength}`;
    array2.layerIndex = topIndex;
    array2.toolbar = false;
    array2.FurtherSetting = false;
    array2.Editable = true;
    setLayersData(LayersData.concat(array2));
  };

  return (
    <>
      <div
        ref={containerRef}
        onBlur={out}
        tabIndex="1"
        style={{
          //doing this because all panels are moved to left now.
          display: "none",
          zIndex: 4000,
          position: "absolute",
          left:
            props.type !== "AnimatedText" ? position.x - 155 : position.x - 310,
          top: position.y,
          width: props.type === "AnimatedText" && "30%",
        }}
      >
        {props.type === "Video" && (
          <>
            <div key={props.keys} className="Setting_Container">
              <div className="Setting_Box">
                <div style={{ width: "100%", height: "100%" }}>
                  {props.SliderShow === true && (
                    <OptionPopUp
                      setSliderShow={props.setSliderShow}
                      setoverlaydiv={props.setoverlaydiv}
                      setoverlayHide={props.setoverlayHide}
                      PopType="opacity"
                      values={props.values}
                      NowOpacity={props.values.opacity * 100}
                    />
                  )}
                  <div className="Setting_Menu">
                    {/* <div className="Setting_Menu_Items" >

                        <div className="Setting_Single_items" >
                            <div className="Items_label" ></div>
                            <div className="color_container" >
                                <div className="styles_button" >
                                    <div className="Style_Button_style" >
                                        <span className="material-icons" >swap_horiz</span>
                                    </div>
                                    <div className="styles_title" >Swap</div>
                                </div>
                            </div>
                        </div>
                    </div> */}

                    <div className="Setting_Menu_Items2 Setting_Menu_Items">
                      <div
                        className={
                          props.values.flip === "scaleX(1)"
                            ? "Setting_Single_items"
                            : "Setting_Single_items active"
                        }
                      >
                        <div className="Items_label"></div>
                        <div className="color_container">
                          <div className="styles_button">
                            <div
                              className="Style_Button_style"
                              onClick={FlipFun}
                            >
                              <span className="material-icons">flip</span>
                            </div>
                            <div className="styles_title">Flip</div>
                          </div>
                        </div>
                      </div>

                      <div className="Setting_Single_items">
                        <div className="Items_label"></div>
                        <div className="opacity">
                          <div className="opacity styles_button">
                            <div
                              className="Style_Button_style"
                              onClick={OpacityChanger}
                            >
                              <span className="material-icons">
                                blur_linear
                              </span>
                            </div>
                            <div className="styles_title">Opacity</div>
                          </div>
                        </div>
                      </div>

                      <div
                        className={
                          props.values.lock
                            ? "Setting_Single_items active"
                            : "Setting_Single_items"
                        }
                      >
                        <div className="Items_label"></div>
                        <div className="styles_button">
                          <div className="Style_Button_style" onClick={lockFun}>
                            <span className="material-icons">lock</span>
                          </div>
                          <div className="styles_title">Lock</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {props.overlaydiv === true && (
                <div
                  onClick={OverlayTouch}
                  data_set="HiddenOverlay"
                  className="hiddenOverlay"
                />
              )}
            </div>
          </>
        )}
        {props.type === "Character" && (
          <>
            <div key={props.keys} className="Setting_Container">
              <div className="Setting_Box">
                <div style={{ width: "100%", height: "100%" }}>
                  {props.SliderShow === true && (
                    <OptionPopUp
                      setSliderShow={props.setSliderShow}
                      setoverlaydiv={props.setoverlaydiv}
                      setoverlayHide={props.setoverlayHide}
                      PopType="opacity"
                      values={props.values}
                      NowOpacity={props.values.opacity * 100}
                    />
                  )}
                  <div className="Setting_Menu">
                    <div className="Setting_Menu_Items">
                      {/* commenting it out as arrangement working form the timeline */}
                      {/* <div className="Setting_Single_items">
                        <div className="Items_label"></div>
                        <div className="color_container">
                          {LayersData.length == 1 && (
                            <div
                              className="styles_button"
                              style={{ opacity: 0.5 }}
                            >
                              <div className="Style_Button_style">
                                <span className="material-icons-outlined">
                                  layers
                                </span>
                              </div>
                              <div className="styles_title">Arrange</div>
                            </div>
                          )}

                          {LayersData.length > 1 && (
                            <div
                              className="styles_button"
                              onClick={LayerArrange}
                            >
                              <div className="Style_Button_style">
                                <span className="material-icons-outlined">
                                  layers
                                </span>
                              </div>
                              <div className="styles_title">Arrange</div>
                            </div>
                          )}
                        </div>
                      </div> */}
                      {/* Commenting it because A to Z is not functional yet. */}
                      {/* <div className="Setting_Single_items">
                        <div className="Items_label"></div>
                        <div className="styles_button">
                          <div className="Style_Button_style" onClick={AtoZ}>
                            <span className="material-icons">moving</span>
                          </div>
                          <div className="styles_title">A to Z</div>
                        </div>
                      </div> */}
                      {/* <div className="Setting_Single_items" >
                                        <div className="Items_label" ></div>
                                        <div className="color_container" >
                                            <div className="styles_button" >
                                                <div className="Style_Button_style" >
                                                    <span className="material-icons" >draw</span>
                                                </div>
                                                <div className="styles_title" >Editor</div>
                                            </div>
                                        </div>
                                    </div> */}
                    </div>

                    <div className="Setting_Menu_Items2 Setting_Menu_Items">
                      <div
                        className={
                          props.values.flip === "scaleX(1)"
                            ? "Setting_Single_items"
                            : "Setting_Single_items active"
                        }
                      >
                        <div className="Items_label"></div>{" "}
                        <div className="color_container">
                          {" "}
                          <div className="styles_button">
                            <div
                              className="Style_Button_style"
                              onClick={FlipFun}
                            >
                              <span className="material-icons">flip</span>
                            </div>
                            <div className="styles_title">Flip</div>
                          </div>
                        </div>
                      </div>
                      <div className="Setting_Single_items">
                        <div className="Items_label"></div>
                        <div className="color_container">
                          <div className="styles_button">
                            <div
                              className="Style_Button_style"
                              onClick={(event) => {
                                openPoses(event);
                              }}
                            >
                              <span className="material-icons">
                                directions_run
                              </span>
                            </div>
                            <div className="styles_title">Poses</div>
                          </div>
                        </div>
                      </div>

                      <div className="Setting_Single_items">
                        <div className="Items_label"></div>
                        <div className="opacity">
                          <div className="opacity styles_button">
                            <div
                              className="Style_Button_style"
                              onClick={OpacityChanger}
                            >
                              <span className="material-icons">
                                blur_linear
                              </span>
                            </div>
                            <div className="styles_title">Opacity</div>
                          </div>
                        </div>
                      </div>

                      <div
                        className={
                          hasMotion(props.values)
                            ? "Setting_Single_items active"
                            : "Setting_Single_items"
                        }
                        title="Move from A to Z"
                      >
                        <div className="Items_label"></div>
                        <div className="styles_button">
                          <div className="Style_Button_style" onClick={MoveAtoZ}>
                            <span className="material-icons">moving</span>
                          </div>
                          <div className="styles_title">Move</div>
                        </div>
                      </div>
                      <div
                        className={
                          props.values.lock
                            ? "Setting_Single_items active"
                            : "Setting_Single_items"
                        }
                      >
                        <div className="Items_label"></div>
                        <div className="styles_button">
                          <div className="Style_Button_style" onClick={lockFun}>
                            <span className="material-icons">lock</span>
                          </div>
                          <div className="styles_title">Lock</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {props.overlaydiv === true && (
                <div
                  onClick={OverlayTouch}
                  data_set="HiddenOverlay"
                  className="hiddenOverlay"
                />
              )}
            </div>
          </>
        )}
        {props.type === "AnimatedText" && (
          <>
            <div
              key={props.keys}
              className="Setting_Container"
              style={{ width: "100%" }}
            >
              <div className="Setting_Box">
                <div style={{ width: "100%", height: "100%" }}>
                  {props.SliderShow === true && (
                    <OptionPopUp
                      setSliderShow={props.setSliderShow}
                      setoverlaydiv={props.setoverlaydiv}
                      setoverlayHide={props.setoverlayHide}
                      PopType="opacity"
                      values={props.values}
                      NowOpacity={props.values.opacity * 100}
                    />
                  )}

                  <div className="Setting_Menu">
                    <div className="Setting_Menu_Items">
                      <div className="Setting_Single_items">
                        <div className="Items_label"></div>
                        <div className="color_container">
                          {AnimatedTextData?.JSONValue?.fromAssets
                            ? AnimatedTextData?.JSONValue?.assets.map(
                                (layer_value) => {
                                  // debugger
                                  const _name =
                                    layer_value.layers[0].t?.d?.k[0]?.s?.t;
                                  const _size =
                                    layer_value.layers[0].t?.d?.k[0]?.s?.s;
                                  const _nm =
                                    layer_value.layers[0].nm.toLowerCase();
                                  //debugger;
                                  return _nm.includes("text") &&
                                    layer_value.layers[0]?.t?.d?.k[0]?.s
                                      ?.isTextBox ? (
                                    <div style={{ fontSize: "14px" }}>
                                      <input
                                        name={_name}
                                        id={_name}
                                        defaultValue={_name}
                                        style={{
                                          border: "none",
                                          width: "68%",
                                          marginLeft: "120px",
                                        }}
                                        onChange={(e) => {
                                          layer_value.layers[0].t.d.k[0].s.t =
                                            e.target.value;
                                          // setState(!State)
                                        }}
                                      />
                                      <div
                                        style={{
                                          whiteSpace: "nowrap",
                                          width: "250px",
                                          marginLeft: "120px",
                                          marginTop: "1%",
                                        }}
                                      >
                                        <label for="id1">Font:</label>
                                        <select
                                          style={{
                                            border: "none",
                                            width: "88%",
                                          }}
                                          value={
                                            AnimatedTextData.googleFontSetting
                                              .fontName
                                          }
                                          onChange={(e) => {
                                            AnimatedTextData.googleFontSetting.fontName =
                                              e.target.value;
                                            const _SelectedGoogleFont =
                                              GoogleFonts.find(
                                                (x) =>
                                                  x.fontName == e.target.value
                                              );
                                            AnimatedTextData.JSONValue.fonts.list[0].fFamily =
                                              _SelectedGoogleFont.fontFamily;
                                            AnimatedTextData.JSONValue.fonts.list[0].fName =
                                              _SelectedGoogleFont.fontName;
                                            setState(!State);
                                          }}
                                        >
                                          {GoogleFonts.map((value) => (
                                            <option value={value.fontName}>
                                              {value.fontName}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                      <div
                                        style={{
                                          whiteSpace: "nowrap",
                                          width: "250px",
                                          marginLeft: "120px",
                                        }}
                                      >
                                        <label for="id1">Size:</label>
                                        <input
                                          type="text"
                                          name={_size}
                                          id={_size}
                                          value={_size}
                                          style={{
                                            border: "none",
                                            width: "89%",
                                          }}
                                          onChange={(e) => {
                                            layer_value.layers[0].t.d.k[0].s.s =
                                              e.target.value;
                                            setState(!State);
                                          }}
                                          // onBlur = {e =>{
                                          //     const _array = Array.from(LayersData);
                                          //     const _index = _array.findIndex(x => x == props.values)
                                          //     _array[_index] = props.values
                                          //     _array[_index].LoadLottie = true;
                                          //     _array[_index].DrapEndAnimatedText = false;
                                          //     setLayersData(_array)
                                          // }}
                                        />
                                      </div>
                                    </div>
                                  ) : (
                                    <div
                                      className="styles_button"
                                      style={{ opacity: 0.5 }}
                                      onClick={(e) => {
                                        props.values.JSONValue.assets.map(
                                          (x) => {
                                            const name =
                                              x.layers[0].nm.toLowerCase();
                                            if (name.includes("text"))
                                              if (x.layers[0]?.t?.d?.k[0]?.s)
                                                x.layers[0].t.d.k[0].s.isTextBox = false;
                                          }
                                        );
                                        layer_value.layers[0].t.d.k[0].s.isTextBox = true;
                                        setState(!State);
                                      }}
                                    >
                                      <div className="Style_Button_style">
                                        <div
                                          className="styles_title"
                                          style={{
                                            fontSize: "14px",
                                            marginLeft: "12%",
                                            textAlign: "right",
                                          }}
                                        >
                                          {
                                            layer_value.layers[0].t?.d?.k[0]?.s
                                              ?.t
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                              )
                            : AnimatedTextData?.JSONValue?.layers.map(
                                (layer_value) => {
                                  const _name = layer_value.t?.d?.k[0]?.s?.t;
                                  const _size = layer_value.t?.d?.k[0]?.s?.s;
                                  const _nm = layer_value.nm.toLowerCase();
                                  //debugger;
                                  return _nm.includes("text") &&
                                    layer_value.t?.d?.k[0]?.s?.isTextBox ? (
                                    <div style={{ fontSize: "14px" }}>
                                      <input
                                        name={_name}
                                        id={_name}
                                        defaultValue={_name}
                                        style={{
                                          border: "none",
                                          width: "68%",
                                          marginLeft: "120px",
                                        }}
                                        onChange={(e) => {
                                          layer_value.t.d.k[0].s.t =
                                            e.target.value;
                                          // setState(!State)
                                        }}
                                      />
                                      <div
                                        style={{
                                          whiteSpace: "nowrap",
                                          width: "250px",
                                          marginLeft: "120px",
                                          marginTop: "1%",
                                        }}
                                      >
                                        <label for="id1">Font:</label>
                                        <select
                                          style={{
                                            border: "none",
                                            width: "88%",
                                          }}
                                          value={
                                            AnimatedTextData.googleFontSetting
                                              .fontName
                                          }
                                          onChange={(e) => {
                                            AnimatedTextData.googleFontSetting.fontName =
                                              e.target.value;
                                            const _SelectedGoogleFont =
                                              GoogleFonts.find(
                                                (x) =>
                                                  x.fontName == e.target.value
                                              );
                                            AnimatedTextData.JSONValue.fonts.list[0].fFamily =
                                              _SelectedGoogleFont.fontFamily;
                                            AnimatedTextData.JSONValue.fonts.list[0].fName =
                                              _SelectedGoogleFont.fontName;
                                            setState(!State);
                                          }}
                                        >
                                          {GoogleFonts.map((value) => (
                                            <option value={value.fontName}>
                                              {value.fontName}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                      <div
                                        style={{
                                          whiteSpace: "nowrap",
                                          width: "250px",
                                          marginLeft: "120px",
                                        }}
                                      >
                                        <label for="id1">Size:</label>
                                        <input
                                          type="text"
                                          name={_size}
                                          id={_size}
                                          value={_size}
                                          style={{
                                            border: "none",
                                            width: "89%",
                                          }}
                                          onChange={(e) => {
                                            layer_value.t.d.k[0].s.s =
                                              e.target.value;
                                            setState(!State);
                                          }}
                                          // onBlur = {e =>{
                                          //     const _array = Array.from(LayersData);
                                          //     const _index = _array.findIndex(x => x == props.values)
                                          //     _array[_index] = props.values
                                          //     _array[_index].LoadLottie = true;
                                          //     _array[_index].DrapEndAnimatedText = false;
                                          //     setLayersData(_array)
                                          // }}
                                        />
                                      </div>
                                    </div>
                                  ) : (
                                    <div
                                      className="styles_button"
                                      style={{ opacity: 0.5 }}
                                      onClick={(e) => {
                                        props.values.JSONValue.layers.map(
                                          (x) => {
                                            const name = x.nm.toLowerCase();
                                            if (name.includes("text"))
                                              x.t.d.k[0].s.isTextBox = false;
                                          }
                                        );
                                        layer_value.t.d.k[0].s.isTextBox = true;
                                        setState(!State);
                                      }}
                                    >
                                      <div className="Style_Button_style">
                                        <div
                                          className="styles_title"
                                          style={{
                                            fontSize: "14px",
                                            marginLeft: "12%",
                                            textAlign: "right",
                                          }}
                                        >
                                          {layer_value.t?.d?.k[0]?.s?.t}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                              )}

                          <button
                            style={{ width: "100%" }}
                            onClick={(e) => {
                              const _array = Array.from(LayersData);
                              const _index = _array.findIndex(
                                (x) => x == AnimatedTextData
                              );
                              _array[_index] = AnimatedTextData;
                              _array[_index].LoadLottie = true;
                              _array[_index].DrapEndAnimatedText = false;
                              _array[_index].Added = true;
                              // setLayersData(_array)

                              _array[_index] = AnimatedTextData;
                              setLayersData(_array);
                            }}
                          >
                            Apply
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {props.type === "Props" && (
          <>
            <div key={props.keys} className="Setting_Container">
              <div className="Setting_Box">
                <div style={{ width: "100%", height: "100%" }}>
                  {props.SliderShow === true && (
                    <OptionPopUp
                      setSliderShow={props.setSliderShow}
                      setoverlaydiv={props.setoverlaydiv}
                      setoverlayHide={props.setoverlayHide}
                      PopType="opacity"
                      values={props.values}
                      NowOpacity={props.values.opacity * 100}
                    />
                  )}
                  <div className="Setting_Menu">
                    <div className="Setting_Menu_Items2 Setting_Menu_Items">
                      <div
                        className={
                          props.values.flip === "scaleX(1)"
                            ? "Setting_Single_items"
                            : "Setting_Single_items active"
                        }
                      >
                        <div className="Items_label"></div>{" "}
                        <div className="color_container">
                          {" "}
                          <div className="styles_button">
                            <div
                              className="Style_Button_style"
                              onClick={FlipFun}
                            >
                              <span className="material-icons">flip</span>
                            </div>
                            <div className="styles_title">Flip</div>
                          </div>
                        </div>
                      </div>
                      <div className="Setting_Single_items">
                        <div className="Items_label"></div>
                        <div className="opacity">
                          <div className="opacity styles_button">
                            <div
                              className="Style_Button_style"
                              onClick={OpacityChanger}
                            >
                              <span className="material-icons">
                                blur_linear
                              </span>
                            </div>
                            <div className="styles_title">Opacity</div>
                          </div>
                        </div>
                      </div>

                      <div
                        className={
                          hasMotion(props.values)
                            ? "Setting_Single_items active"
                            : "Setting_Single_items"
                        }
                        title="Move from A to Z"
                      >
                        <div className="Items_label"></div>
                        <div className="styles_button">
                          <div className="Style_Button_style" onClick={MoveAtoZ}>
                            <span className="material-icons">moving</span>
                          </div>
                          <div className="styles_title">Move</div>
                        </div>
                      </div>
                      <div
                        className={
                          props.values.lock
                            ? "Setting_Single_items active"
                            : "Setting_Single_items"
                        }
                      >
                        <div className="Items_label"></div>
                        <div className="styles_button">
                          <div className="Style_Button_style" onClick={lockFun}>
                            <span className="material-icons">lock</span>
                          </div>
                          <div className="styles_title">Lock</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {props.overlaydiv === true && (
                <div
                  onClick={OverlayTouch}
                  data_set="HiddenOverlay"
                  className="hiddenOverlay"
                />
              )}
            </div>
          </>
        )}
        {props.type === "image" && (
          <>
            <div key={props.keys} className="Setting_Container">
              <div className="Setting_Box">
                <div style={{ width: "100%", height: "100%" }}>
                  {props.SliderShow === true && (
                    <OptionPopUp
                      setSliderShow={props.setSliderShow}
                      setoverlaydiv={props.setoverlaydiv}
                      setoverlayHide={props.setoverlayHide}
                      PopType="opacity"
                      values={props.values}
                      NowOpacity={props.values.opacity * 100}
                    />
                  )}
                  <div className="Setting_Menu">
                    <div className="Setting_Menu_Items">
                      <div className="Setting_Single_items">
                        <div className="Items_label"></div>
                        <div className="color_container">
                          {LayersData.length == 1 && (
                            <div
                              className="styles_button"
                              style={{ opacity: 0.5 }}
                            >
                              <div className="Style_Button_style">
                                <span className="material-icons-outlined">
                                  layers
                                </span>
                              </div>
                              <div className="styles_title">Arrange</div>
                            </div>
                          )}
                          {LayersData.length > 1 && (
                            <div
                              className="styles_button"
                              onClick={LayerArrange}
                            >
                              <div className="Style_Button_style">
                                <span className="material-icons-outlined">
                                  layers
                                </span>
                              </div>
                              <div className="styles_title">Arrange</div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="Setting_Single_items">
                        <div className="Items_label"></div>
                        <div className="color_container">
                          <div className="styles_button">
                            <div
                              className="Style_Button_style"
                              onClick={openCropper}
                            >
                              <span className="material-icons">crop</span>
                            </div>
                            <div className="styles_title">crop</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="Setting_Menu_Items2 Setting_Menu_Items">
                      <div
                        className={
                          props.values.flip === "scaleX(1)"
                            ? "Setting_Single_items"
                            : "Setting_Single_items active"
                        }
                      >
                        <div className="Items_label"></div>
                        <div className="color_container">
                          <div className="styles_button">
                            <div
                              className="Style_Button_style"
                              onClick={FlipFun}
                            >
                              <span className="material-icons">flip</span>
                            </div>
                            <div className="styles_title">Flip</div>
                          </div>
                        </div>
                      </div>
                      <div className="Setting_Single_items">
                        <div className="Items_label"></div>
                        <div className="color_container">
                          <div className="styles_button">
                            <div className="Style_Button_style">
                              <span className="material-icons">
                                auto_fix_high
                              </span>
                            </div>
                            <div className="styles_title">Edit Img</div>
                          </div>
                        </div>
                      </div>
                      <div className="Setting_Single_items">
                        <div className="Items_label"></div>
                        <div className="opacity">
                          <div className="opacity styles_button">
                            <div
                              className="Style_Button_style"
                              onClick={OpacityChanger}
                            >
                              <span className="material-icons">
                                blur_linear
                              </span>
                            </div>
                            <div className="styles_title">Opacity</div>
                          </div>
                        </div>
                      </div>
                      <div className="Setting_Single_items">
                        <div className="Items_label"></div>
                        <div className="styles_button">
                          <div
                            className="Style_Button_style"
                            onClick={Duplicate}
                          >
                            <span className="material-icons">content_copy</span>
                          </div>
                          <div className="styles_title">Duplicate</div>
                        </div>
                      </div>
                      <div
                        className={
                          hasMotion(props.values)
                            ? "Setting_Single_items active"
                            : "Setting_Single_items"
                        }
                        title="Move from A to Z"
                      >
                        <div className="Items_label"></div>
                        <div className="styles_button">
                          <div className="Style_Button_style" onClick={MoveAtoZ}>
                            <span className="material-icons">moving</span>
                          </div>
                          <div className="styles_title">Move</div>
                        </div>
                      </div>
                      <div
                        className={
                          props.values.lock
                            ? "Setting_Single_items active"
                            : "Setting_Single_items"
                        }
                      >
                        <div className="Items_label"></div>
                        <div className="styles_button">
                          <div className="Style_Button_style" onClick={lockFun}>
                            <span className="material-icons">lock</span>
                          </div>
                          <div className="styles_title">Lock</div>
                        </div>
                      </div>

                      <div className="Setting_Single_items">
                        <div className="Items_label"></div>
                        <div className="styles_button">
                          <div
                            className="Style_Button_style"
                            onClick={setImgAsBG}
                          >
                            <span className="material-icons">wallpaper</span>
                          </div>
                          <div className="styles_title">Set Background</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {props.overlaydiv === true && (
                <div
                  onClick={OverlayTouch}
                  data_set="HiddenOverlay"
                  className="hiddenOverlay"
                />
              )}
            </div>
          </>
        )}
        {props.type === "text" && (
          <>
            <div key={props.keys} className="Setting_Container">
              <div className="Setting_Box">
                <div style={{ width: "100%", height: "100%" }}>
                  {props.SliderShow === true && (
                    <OptionPopUp
                      setSliderShow={props.setSliderShow}
                      setoverlaydiv={props.setoverlaydiv}
                      setoverlayHide={props.setoverlayHide}
                      PopType="opacity"
                      values={props.values}
                      NowOpacity={props.values.opacity * 100}
                    />
                  )}

                  {props.colorShow === true && (
                    <OptionPopUp
                      setSliderShow={props.setSliderShow}
                      setoverlaydiv={props.setoverlaydiv}
                      setcolorShow={props.setcolorShow}
                      setoverlayHide={props.setoverlayHide}
                      PopType="ColorPicker"
                      values={props.values}
                    />
                  )}

                  {props.FontShow === true && (
                    <OptionPopUp
                      setSliderShow={props.setSliderShow}
                      setoverlaydiv={props.setoverlaydiv}
                      setFontShow={props.setFontShow}
                      setoverlayHide={props.setoverlayHide}
                      PopType="fontsDropDown"
                      values={props.values}
                    />
                  )}

                  <div className="Setting_Menu">
                    <div className="Setting_Menu_Items">
                      <div className="Menu_Items_Inner" onClick={FontsSetter}>
                        <div className="Items_label"></div>
                        <div className="Item_size">
                          <div className="InnerInputPill">
                            <span
                              className="furtherActionInput"
                              style={{ width: "96px", textAlign: "left" }}
                            >
                              FontFamily
                            </span>
                            <div>
                              <span className="material-icons">
                                arrow_drop_down
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="Menu_Items_Inner">
                        <div className="Items_label"></div>
                        <div className="Item_size">
                          <div className="InnerInputPill">
                            <div>
                              <span
                                className="material-icons minusSpan"
                                onMouseDown={decrSizeMouseDown}
                                onMouseUp={decrSizeMouseUp}
                              >
                                remove_circle_outline
                              </span>
                            </div>
                            <span
                              className="furtherActionInput"
                              style={{ width: "72px" }}
                            >
                              {fontsize}
                            </span>
                            <div>
                              <span
                                className="material-icons PlusSpan"
                                onMouseDown={incrSizeMouseDown}
                                onMouseUp={incrSizeMouseUp}
                              >
                                add_circle_outline
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="Menu_Items_Inner">
                        <div className="Items_label"></div>
                        <div className="Item_textStyle">
                          <div className="Bold styles_button">
                            <div className="Style_Button_style">
                              <span
                                className={
                                  props.values.fontWeight === "normal"
                                    ? "material-icons"
                                    : "material-icons mini-setting-items active"
                                }
                                onClick={fontBold}
                              >
                                format_bold
                              </span>
                            </div>
                          </div>
                          <div className="Italic styles_button">
                            <div className="Style_Button_style">
                              <span
                                className={
                                  props.values.Fontstyle === "normal"
                                    ? "material-icons"
                                    : "material-icons mini-setting-items active"
                                }
                                onClick={FontItalic}
                              >
                                format_italic
                              </span>
                            </div>
                          </div>
                          <div className="UnderLine styles_button">
                            <div className="Style_Button_style">
                              <span
                                className={
                                  props.values.textDec === "none"
                                    ? "material-icons"
                                    : "material-icons mini-setting-items active"
                                }
                                onClick={TextUnderline}
                              >
                                format_underlined
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="Menu_Items_Inner">
                        <div className="Items_label"></div>
                        <div className="Item_Text_Position">
                          <div className="align_left styles_button">
                            <div className="Style_Button_style">
                              <span
                                className={
                                  props.values.Align == "left"
                                    ? "material-icons mini-setting-items active"
                                    : "material-icons"
                                }
                                onClick={() => Aligned("left")}
                              >
                                format_align_left
                              </span>
                            </div>
                          </div>

                          <div className="align_center styles_button">
                            <div className="Style_Button_style">
                              <span
                                className={
                                  props.values.Align == "center"
                                    ? "material-icons mini-setting-items active"
                                    : "material-icons"
                                }
                                onClick={() => Aligned("center")}
                              >
                                format_align_center
                              </span>
                            </div>
                          </div>

                          <div className="align_right styles_button">
                            <div className="Style_Button_style">
                              <span
                                className={
                                  props.values.Align == "right"
                                    ? "material-icons mini-setting-items active"
                                    : "material-icons"
                                }
                                onClick={() => Aligned("right")}
                              >
                                format_align_right
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="Setting_Menu_Items2 Setting_Menu_Items">
                      <div className="Setting_Single_items">
                        <div className="Items_label"></div>
                        <div className="styles_button">
                          <div
                            className="Style_Button_style"
                            onClick={Duplicate}
                          >
                            <span className="material-icons">content_copy</span>
                          </div>
                          <div className="styles_title">Duplicate</div>
                        </div>
                      </div>
                      <div className="Setting_Single_items">
                        <div className="Items_label"></div>
                        <div className="color_container">
                          <div className="styles_button">
                            <div
                              className="Style_Button_style"
                              onClick={ColorSetter}
                            >
                              <span className="material-icons">color_lens</span>
                            </div>
                            <div className="styles_title">Color</div>
                          </div>
                        </div>
                      </div>

                      <div className="Setting_Single_items">
                        <div className="Items_label"></div>
                        <div className="opacity">
                          <div className="opacity styles_button">
                            <div
                              className="Style_Button_style"
                              onClick={OpacityChanger}
                            >
                              <span className="material-icons">
                                blur_linear
                              </span>
                            </div>
                            <div className="styles_title">Opacity</div>
                          </div>
                        </div>
                      </div>

                      <div
                        className={
                          hasMotion(props.values)
                            ? "Setting_Single_items active"
                            : "Setting_Single_items"
                        }
                        title="Move from A to Z"
                      >
                        <div className="Items_label"></div>
                        <div className="styles_button">
                          <div className="Style_Button_style" onClick={MoveAtoZ}>
                            <span className="material-icons">moving</span>
                          </div>
                          <div className="styles_title">Move</div>
                        </div>
                      </div>
                      <div
                        className={
                          props.values.lock
                            ? "Setting_Single_items active"
                            : "Setting_Single_items"
                        }
                        style={{ width: "100%" }}
                      >
                        <div className="Items_label"></div>
                        <div className="styles_button">
                          <div className="Style_Button_style" onClick={lockFun}>
                            <span className="material-icons">lock</span>
                          </div>
                          <div className="styles_title">Lock</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {props.overlaydiv === true && (
                <div
                  onClick={OverlayTouch}
                  data_set="HiddenOverlay"
                  className="hiddenOverlay"
                />
              )}
            </div>
          </>
        )}
        {props.type === "basicShape" && (
          <>
            <div key={props.keys} className="Setting_Container">
              <div className="Setting_Box">
                <div style={{ width: "100%", height: "100%" }}>
                  {props.SliderShow === true && (
                    <OptionPopUp
                      setSliderShow={props.setSliderShow}
                      setoverlaydiv={props.setoverlaydiv}
                      setoverlayHide={props.setoverlayHide}
                      PopType="opacity"
                      values={props.values}
                      NowOpacity={props.values.opacity * 100}
                    />
                  )}
                  {props.colorShow === true && (
                    <OptionPopUp
                      AciveShapeColor={props.AciveShapeColor}
                      setAciveShapeColor={props.setAciveShapeColor}
                      setSliderShow={props.setSliderShow}
                      setoverlaydiv={props.setoverlaydiv}
                      setcolorShow={props.setcolorShow}
                      setoverlayHide={props.setoverlayHide}
                      PopType="ColorPicker"
                      values={props.values}
                    />
                  )}
                  {props.StrokeShow === true && (
                    <OptionPopUp
                      setSliderShow={props.setSliderShow}
                      setoverlaydiv={props.setoverlaydiv}
                      StrokeShow={props.StrokeShow}
                      setoverlayHide={props.setoverlayHide}
                      PopType="Stroke"
                      values={props.values}
                      stroke={props.values.stroke}
                      setStrokeShow={props.setStrokeShow}
                    />
                  )}
                  <div className="Setting_Menu">
                    <div className="Setting_Menu_Items2 Setting_Menu_Items">
                      <div
                        className={
                          props.values.flip === "scaleX(1)"
                            ? "Setting_Single_items"
                            : "Setting_Single_items active"
                        }
                      >
                        <div className="Items_label"></div>
                        <div className="color_container">
                          <div className="styles_button">
                            <div
                              className="Style_Button_style"
                              onClick={FlipFun}
                            >
                              <span className="material-icons">flip</span>
                            </div>
                            <div className="styles_title">Flip</div>
                          </div>
                        </div>
                      </div>
                      <div className="Setting_Single_items">
                        <div className="Items_label"></div>
                        <div className="opacity">
                          <div className="opacity styles_button">
                            <div
                              className="Style_Button_style"
                              onClick={OpacityChanger}
                            >
                              <span className="material-icons">
                                blur_linear
                              </span>
                            </div>
                            <div className="styles_title">Opacity</div>
                          </div>
                        </div>
                      </div>
                      <div className="Setting_Single_items">
                        <div className="Items_label"></div>
                        <div className="color_container">
                          <div className="styles_button">
                            <div
                              className="Style_Button_style"
                              onClick={ColorSetter}
                            >
                              <span className="material-icons">color_lens</span>
                            </div>
                            <div className="styles_title">Color</div>
                          </div>
                        </div>
                      </div>
                      <div className="Setting_Single_items">
                        <div className="Items_label"></div>
                        <div className="styles_button">
                          <div
                            className="Style_Button_style"
                            onClick={TransparencyChanger}
                          >
                            <span className="material-icons">border_outer</span>
                          </div>
                          <div className="styles_title">Stroke</div>
                        </div>
                      </div>
                      <div className="Setting_Single_items">
                        <div className="Items_label"></div>
                        <div className="styles_button">
                          <div
                            className="Style_Button_style"
                            onClick={setTransparancy}
                          >
                            <span className="material-icons">
                              invert_colors_off
                            </span>
                          </div>
                          <div className="styles_title">Transparency</div>
                        </div>
                      </div>
                      <div className="Setting_Single_items">
                        <div className="Items_label"></div>
                        <div className="styles_button">
                          <div
                            className="Style_Button_style"
                            onClick={Duplicate}
                          >
                            <span className="material-icons">content_copy</span>
                          </div>
                          <div className="styles_title">Duplicate</div>
                        </div>
                      </div>
                      <div
                        className={
                          hasMotion(props.values)
                            ? "Setting_Single_items active"
                            : "Setting_Single_items"
                        }
                        title="Move from A to Z"
                      >
                        <div className="Items_label"></div>
                        <div className="styles_button">
                          <div className="Style_Button_style" onClick={MoveAtoZ}>
                            <span className="material-icons">moving</span>
                          </div>
                          <div className="styles_title">Move</div>
                        </div>
                      </div>
                      <div
                        className={
                          props.values.lock
                            ? "Setting_Single_items active"
                            : "Setting_Single_items"
                        }
                      >
                        <div className="Items_label"></div>
                        <div className="styles_button">
                          <div className="Style_Button_style" onClick={lockFun}>
                            <span className="material-icons">lock</span>
                          </div>
                          <div className="styles_title">Lock</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {props.overlaydiv === true && (
                <div
                  onClick={OverlayTouch}
                  data_set="HiddenOverlay"
                  className="hiddenOverlay"
                />
              )}
            </div>
          </>
        )}
        {props.type === "Shape" && (
          <>
            <div key={props.keys} className="Setting_Container">
              <div className="Setting_Box">
                <div style={{ width: "100%", height: "100%" }}>
                  {props.SliderShow === true && (
                    <OptionPopUp
                      setSliderShow={props.setSliderShow}
                      setoverlaydiv={props.setoverlaydiv}
                      setoverlayHide={props.setoverlayHide}
                      PopType="opacity"
                      values={props.values}
                      NowOpacity={props.values.opacity * 100}
                    />
                  )}
                  {props.colorShow === true && (
                    <OptionPopUp
                      setSliderShow={props.setSliderShow}
                      setoverlaydiv={props.setoverlaydiv}
                      setcolorShow={props.setcolorShow}
                      setoverlayHide={props.setoverlayHide}
                      PopType="ColorPicker"
                      values={props.values}
                    />
                  )}
                  <div className="Setting_Menu">
                    <div className="Setting_Menu_Items2 Setting_Menu_Items">
                      <div
                        className={
                          props.values.flip === "scaleX(1)"
                            ? "Setting_Single_items"
                            : "Setting_Single_items active"
                        }
                      >
                        <div className="Items_label"></div>
                        <div className="color_container">
                          <div className="styles_button">
                            <div
                              className="Style_Button_style"
                              onClick={FlipFun}
                            >
                              <span className="material-icons">flip</span>
                            </div>
                            <div className="styles_title">Flip</div>
                          </div>
                        </div>
                      </div>
                      <div className="Setting_Single_items">
                        <div className="Items_label"></div>
                        <div className="opacity">
                          <div className="opacity styles_button">
                            <div
                              className="Style_Button_style"
                              onClick={OpacityChanger}
                            >
                              <span className="material-icons">
                                blur_linear
                              </span>
                            </div>
                            <div className="styles_title">Opacity</div>
                          </div>
                        </div>
                      </div>
                      <div className="Setting_Single_items">
                        <div className="Items_label"></div>
                        <div className="color_container">
                          <div className="styles_button">
                            <div
                              className="Style_Button_style"
                              onClick={ColorSetter}
                            >
                              <span className="material-icons">color_lens</span>
                            </div>
                            <div className="styles_title">Color</div>
                          </div>
                        </div>
                      </div>
                      <div
                        className={
                          hasMotion(props.values)
                            ? "Setting_Single_items active"
                            : "Setting_Single_items"
                        }
                        title="Move from A to Z"
                      >
                        <div className="Items_label"></div>
                        <div className="styles_button">
                          <div className="Style_Button_style" onClick={MoveAtoZ}>
                            <span className="material-icons">moving</span>
                          </div>
                          <div className="styles_title">Move</div>
                        </div>
                      </div>
                      <div
                        className={
                          props.values.lock
                            ? "Setting_Single_items active"
                            : "Setting_Single_items"
                        }
                      >
                        <div className="Items_label"></div>
                        <div className="styles_button">
                          <div className="Style_Button_style" onClick={lockFun}>
                            <span className="material-icons">lock</span>
                          </div>
                          <div className="styles_title">Lock</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {props.overlaydiv === true && (
                <div
                  onClick={OverlayTouch}
                  data_set="HiddenOverlay"
                  className="hiddenOverlay"
                />
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};
export default FurtherSetting;
